import { Controller } from "@hotwired/stimulus"

export default class DismissibleController extends Controller {
  static values = { key: String }
  declare readonly keyValue: string

  connect() {
    if (this.keyValue && localStorage.getItem(this.keyValue) === "dismissed") {
      (this.element as HTMLElement).remove()
    }
  }

  close() {
    if (this.keyValue) {
      localStorage.setItem(this.keyValue, "dismissed")
    }
    (this.element as HTMLElement).remove()
  }
}
